export const linkTop = [
    {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        link: '/service/development',
        linkName: 'Digital-интегратор',
    },
    {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        link: '/service/marketing',
        linkName: 'Интернет-маркетинг',
    },
    {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        link: '/service/outstaff',
        linkName: 'Аутстаф',
    },
];

export const linkBot = [
    {
        link: '/company',
        linkName: 'О компании',
        isBlank: false,
    },
    {
        link: '/service/development',
        linkName: 'Разработка',
        isBlank: false,
    },
    {
        link: '/service/marketing',
        linkName: 'Маркетинг',
        isBlank: false,
    },
    {
        link: 'http://webpractik.ai/',
        linkName: 'ИИ-интегратор',
        isBlank: true,
    },
    {
        link: '/cases',
        linkName: 'Кейсы',
        isBlank: false,
    },
    {
        link: '/contacts',
        linkName: 'Контакты',
        isBlank: false,
    },
    {
        link: 'https://team.webpractik.ru/',
        linkName: 'Команда',
        isBlank: true,
    },
];

export const link = [
    {
        link: '',
        linkName: 'О компании',
        isStatic: true,
        linkDownList: [
            {
                link: '/company',
                linkName: 'Об агентстве',
                isBlank: false,
            },
            {
                link: 'https://team.webpractik.ru/',
                isBlank: true,
                linkName: 'Команда',
            },
        ],
    },
    {
        link: '/service/development',
        linkName: 'Разработка',
        isBlank: false,
    },
    {
        link: '',
        mainLink: '/service/marketing',
        linkName: 'Маркетинг',
        isBig: false,
        linkDownList: [
            {
                link: '/service/marketing/perfomance',
                linkName: 'Перфоманс-маркетинг',
                isBlank: false,
            },
            {
                link: '/service/marketing/seo',
                linkName: 'Поисковая оптимизация',
                isBlank: false,
            },
        ],
    },
    {
        link: 'http://webpractik.ai/',
        linkName: 'ИИ-интегратор',
        isBlank: true,
    },
    {
        link: '/cases',
        linkName: 'Кейсы',
    },
    {
        link: '/contacts',
        linkName: 'Контакты',
    },
];
